import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';

export default class WishlistComponent extends Component {

    get SELECTORS() {
        return {
            container: '.js-wishlist-dropdown',
            main: '.js-wishlist',
            item: '.wishlist .product-item',
            sizeLayer: '.js-sizes',
            addedMsg: '.item-added',
            icon: '.action.wishlist',
            remove: '.js-remove-wish',
            emptyWish: '.js-empty-wishlist-msg',
            qty: '.qty-items',
            nav_wishlist: ".wishlist-nav",
            qtyWishlist: '.wishlistCount',
            qtyWishlistTitle: '.wishlistCount-title',
            qtyWishlistMobile: ".wishlistCount-mobile",
            wishlistEmptySection: "[data-wishlist-empty]",
            wishlistFullSection: "[data-wishlist-full]",
            wishBtn: '.js-wishlist-cta'
        };
    }

    get CLASSES() {
        return {
            show: 'show',
            active: 'active',
            removing: 'removing',
            icon_wishlist_on: "icon-wishlist-on",
            icon_wishlist_off: "icon-wishlist-off",
            addBtnClass: 'js-addtowish',
            addedBtnClass: 'js-added-wish',
            removeBtnClass: 'js-remove-from-wish',
            added: 'icon-wishlist-on',
            notAdded: 'icon-wishlist'
        };
    }

    constructor() {
        super();

        this.timeout = null;
        this.container = $(this.SELECTORS.container);
        this.main = $(this.SELECTORS.main);
        this.item = $(this.SELECTORS.item);
        this.sizeLayer = $(this.SELECTORS.sizeLayer);
        this.addedMsg = $(this.SELECTORS.addedMsg);
        this.icon = $(this.SELECTORS.icon);
        this.remove = $(this.SELECTORS.remove);
        this.updated = false;
        this.qtyWishlist = $(this.SELECTORS.qtyWishlist);
        this.qtyWishlistMobile = $(this.SELECTORS.qtyWishlistMobile);
        this.qtyWishlistTitle = $(this.SELECTORS.qtyWishlistTitle);
        this.wishlistEmptySection = document.querySelector(this.SELECTORS.wishlistEmptySection);
        this.wishlistFullSection = document.querySelector(this.SELECTORS.wishlistFullSection);
        this.wishBtn = document.querySelectorAll(this.SELECTORS.wishBtn);
    }

    appendHtml(html) {
        return new Promise((resolve, reject) => {
            try {
                this.main.html(html);
                resolve()
            } catch (e) {
                reject(e)
            }
        });
    }

    updateWishlist() {

        let ctx = this;
        let $elem = ctx.main;

        return $.ajax({
            url: $elem.data('href'),
            dataType: "html",
            error: function (xhr) {
                console.log(xhr);
            }
        });
    }

    removeProduct(el) {
        let ctx = this;
        let $elem = $(el);
        let url = $elem.data('href');
        let code = $elem.data('code');
        $elem.attr('disabled', 'disabled');

        if ($elem.has('disabled')) {
            $.ajax({
                url: url,
                dataType: "json",
                data: {
                    productCode: code
                },
                type: 'POST',
                success: function () {
                    ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, $elem);
                },
                error: function (xhr) {
                    console.log(xhr);
                }
            });
        }
    }

    updateQtyWishlist(e) {
        let $elem = e;
        let ctx = this;
        let qtyNew = ctx.qtyWishlist.text() - 1;
        ctx.qtyWishlist.text(qtyNew);
        ctx.qtyWishlistMobile.text(qtyNew);
        let qtyNewTitle = ctx.qtyWishlistTitle;
        if (qtyNewTitle != null || typeof qtyNewTitle !== 'undefined') {
            qtyNewTitle.text(' (' + qtyNew + ')');
        }
        $elem.removeAttr('disabled');
        ctx.dotVisibility(qtyNew);
    }

    addQtyWishlist() {
        let ctx = this;
        let qtyNew = parseInt(ctx.qtyWishlist.text()) + 1;
        ctx.qtyWishlist.text(qtyNew);
        ctx.qtyWishlistMobile.text(qtyNew);
        ctx.dotVisibility(qtyNew);
    }

    dotVisibility(qty) {
        if (qty == null || typeof qty == 'undefined') {
            qty = this.qtyWishlist.text();
        }
        this.qtyWishlist.attr("data-wlqty", qty);
    }

    wishlistCheckAjax(code) {
        return new Promise((resolve, reject) => {
            let data = {};
            data[code] = code;
            //
            let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
            $.ajax({
                url: contextPath + "/action/ajax/wishlist-check-product",
                data: {
                    code: code
                },
                success: function (result) {
                    // resolve
                    resolve(result);
                }
            });
        });
    }

    updateWishButton(btn, disable) {
        // check
        if (btn == null) return false;

        if (disable == true) {
            // disable button
            btn.classList.remove(this.CLASSES.addBtnClass);
            btn.classList.add(this.CLASSES.addedBtnClass);
            btn.classList.add(this.CLASSES.removeBtnClass);

        } else {
            // enable button
            btn.classList.add(this.CLASSES.addBtnClass);
            btn.classList.remove(this.CLASSES.addedBtnClass);
            btn.classList.remove(this.CLASSES.removeBtnClass);
        }

        btn.disabled = false;
    }

    selectedSize(target) {
        const ctx = this;
        const parent = $(target).parent().parent();
        let sizeSelected;
        let sizes = parent.siblings(ctx.SELECTORS.sizesForm)[0];
        if (typeof sizes === 'undefined') {
            sizes = parent.parent().siblings(ctx.SELECTORS.sizesForm)[0];
        }
        if ($(sizes).find('.c-pdp-s__select-size').length !== 0) {
            sizeSelected = $(sizes).find(".c-pdp-s__item.selected").data("productCode");
        } else {
            sizeSelected = $(target).data('code');
        }
        return sizeSelected;
    }

    listenBtnWish(btns) {
        // global
        let ctx = this;
        // if not passed
        if (typeof btns == 'undefined') btns = this.wishBtn;
        //
        if (btns != null) {
            btns.forEach(btn => {
                btn.addEventListener("click", (elem) => {
                    // no default action
                    elem.stopPropagation();
                    // in base of button class
                    if (btn.classList.contains(ctx.CLASSES.addBtnClass)) {
                        // adding
                        let url = btn.getAttribute('data-wish-add-url');
                        ctx.addToWishlist(btn, url);
                    } else {
                        // removing
                        let url = btn.getAttribute('data-wish-remove-url');
                        ctx.removeToWishlist(btn, url);
                    }
                });
            });
        }
    }

    addToWishlist(elem, url) {
        // vars
        let ctx = this;
        let code = elem.dataset.code;
        elem.disabled = true;
        // ajax
        doAjax({
            url: url,
            data: {
                code: code
            },
            dataType: "html",
            success: function (resp) {
                ctx.log('added to wishlist', code);
                // n of items on wishlist
                let qty = resp;
                // event
                ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, { elem: elem, qty: qty });
            },
            error: function (xhr) {
                console.log('error in add to wishlist');
            }
        });
    }

    removeToWishlist(elem, url) {
        // vars
        let ctx = this;
        let code = elem.dataset.code;
        elem.disabled = true;
        // ajax
        doAjax({
            url: url,
            dataType: "json",
            data: {
                productCode: code
            },
            type: 'POST',
            success: function (resp) {
                // n of items on wishlist
                let qty = resp.count;
                // launch event
                ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, { elem: elem, qty: qty });
            },
            error: function (xhr) {
                console.log(xhr);
            }
        });
    }

    bindEvents() {

        let ctx = this;

        this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({ event, payload }) => {

            //Remove from miniwishlist when selecting a size in miniwishlist
            let fromMiniWislist = $(payload.button).data('from-wishlist');
            ctx.dotVisibility();
        });


        this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, (e) => {
            let $elem = $(e.payload);
            let code = $elem.data('code');
            $elem.attr('disabled', 'disabled');
            // $(this.SELECTORS.iconWishList+"-"+code).removeClass(this.CLASSES.notAdded).addClass(this.CLASSES.added);

            let url = $elem.data('href');
            this.originalFocus = e.payload;

            if ($elem.has('disabled')) {
                $.ajax({
                    url: url,
                    data: {
                        code: $elem.data('code')
                    },
                    dataType: "html",
                    success: function (resp) {
                        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, $elem);
                        let qty = resp;
                        $(ctx.SELECTORS.qty).text(qty);
                        ctx.dotVisibility(qty);
                    },
                    error: function (xhr) {
                        console.log('error in add to wishlist');
                    }
                }).always(() => {
                    $elem.removeAttr('disabled');
                });
            }

        });

        this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({ event, payload }) => {

            // search the btn with the base product code
            let btnWish = document.querySelector('[data-wishlist-code="' + payload.button.offsetParent.dataset.productCode + '"]') ?? null ;

            if(btnWish){
                let sendRequest = payload.button.dataset.productCode;

                // put in the button the size code
                btnWish.dataset.code = sendRequest;
                //btnWish.dataset.wishlistCode = sendRequest;

                // check size on size seleect
                // go promise
                this.wishlistCheckAjax(sendRequest).then((result) => {
                    // result
                    if (result === 'true') {
                        // if is in WL i disable the button
                        this.updateWishButton(btnWish, true);
                    } else {
                        // if not i enable it
                        this.updateWishButton(btnWish, false);
                    }
                });
            }
        });


        this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({ event, payload }) => {
            this.addQtyWishlist();
            this.updateWishButton(payload.elem, true);
        });

        this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
            this.updateWishlist().always(res => {
                this.appendHtml(res).then(res => {

                    let ctx = this;
                    let $elem = $(e.payload);
                    let code = String($elem.data('code'));
                    let item = $(`div[data-code="${code}"]`);
                    let $qty = e?.payload?.qty;
                    if($qty > 0){
                      if(ctx.wishlistFullSection?.classList?.contains("hidden")){
                        ctx.wishlistFullSection?.classList?.remove("hidden");
                        ctx.wishlistEmptySection?.classList?.add("hidden");
                      }
                    } else {
                      if(ctx.wishlistEmptySection?.classList?.contains("hidden")){
                        ctx.wishlistEmptySection?.classList?.remove("hidden");
                        ctx.wishlistFullSection?.classList?.add("hidden");
                      }
                    }

                    item.addClass(ctx.CLASSES.removing);
                    this.updateQtyWishlist($elem);
                    this.updateWishButton(e.payload.elem, false);
                    setTimeout(function () { item.remove() }, 800);

                });
            });
        });

        $('body').off('click.wishlist').on('click.wishlist', ctx.SELECTORS.remove, function () {
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, this);
        });

        this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, (e) => {
            this.removeProduct(e.payload);
        });

        this.dotVisibility();
    }

    render() {
        this.log('Rendering...');
        this.bindEvents();

        this.listenBtnWish();
    }
}
